import {
  SyncActionBase,
  usePrivateSyncAction,
  UseSyncActionProps,
} from 'modules/integrations/hooks/usePrivateSyncAction'

type HeaderSyncAction = Omit<SyncActionBase, 'tooltip'> & {
  tooltip?: string
}

type UseHeaderSyncActionReturn = {
  headerSyncActions: HeaderSyncAction[]
  syncModal: React.ReactNode | null
}

export const useHeaderSyncAction = (props: UseSyncActionProps = {}): UseHeaderSyncActionReturn => {
  const { syncActions, syncModal } = usePrivateSyncAction(props)

  return {
    headerSyncActions: syncActions.map(({ tooltip, ...rest }) => ({
      ...rest,
      tooltip: tooltip?.({ disabled: rest.disabled ?? false, loading: rest.loading ?? false }),
    })),
    syncModal,
  }
}
